// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cN-S","content":"styles_content__2XFjD","row":"styles_row__1L9TZ","footer":"styles_footer__2BhNB","phraseLength":"styles_phraseLength__21nZD"};